import { render, staticRenderFns } from "./PaidTab.vue?vue&type=template&id=130df2d4&scoped=true"
import script from "./PaidTab.vue?vue&type=script&lang=js"
export * from "./PaidTab.vue?vue&type=script&lang=js"
import style0 from "./PaidTab.vue?vue&type=style&index=0&id=130df2d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130df2d4",
  null
  
)

export default component.exports